import dayjs from 'dayjs';
import type {ForestMass} from '@/domain/entities/ForestMass';
import type {ForestMassDto} from './ForestMassDto';

export const toDto = (domain: ForestMass): ForestMassDto => ({
  uuid: domain.uuid,
  appraiserUuid: domain.appraiserUuid,
  boundary: domain.boundary,
  code: domain.code,
  concello: domain.concello,
  plannedCuttingDate: domain.plannedCuttingDate.toISOString(),
  isCut: domain.isCut,
  realWeight: domain.realWeight ? domain.realWeight * 1000 : undefined,
  createdAt: domain.createdAt.toISOString(),
});

export const toDomain = (dto: ForestMassDto): ForestMass => ({
  ...dto,
  plannedCuttingDate: dayjs(dto.plannedCuttingDate),
  createdAt: dayjs(dto.createdAt),
  realWeight: dto.realWeight ? dto.realWeight / 1000 : undefined,
});
